module.exports = __webpack_public_path__ + "static/media/4.0966c3fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/fleet/4.jpg
// module id = 1185
// module chunks = 0